const faqs = [
  {
    q: '911吃瓜网是什么平台？',
    a: '911吃瓜网是全网最大的一站式黑料汇总平台，专注整理明星、网红、娱乐圈等各领域的内幕曝光与负面新闻合集。我们聚合全网猛料，让吃瓜群众不再错过任何热点事件，是国内最活跃的黑料吃瓜社区之一。',
  },
  {
    q: '平台上的黑料内容是否真实可靠？',
    a: '本平台所有内容来源于公开网络信息整合与用户匿名投稿，我们对每一条黑料进行多源交叉验证后再发布。虽然无法保证100%准确，但我们坚持实事求是原则，标注信息来源与可信度等级，让读者自行判断。',
  },
  {
    q: '如何向911吃瓜网投稿爆料？',
    a: '您可以通过页面底部的「联系我们」区域找到投稿入口，支持文字、图片和链接提交。我们承诺对所有爆料人信息严格保密，采用端到端加密传输，绝不泄露投稿人身份。爆料一经采纳，还将获得平台专属曝光位。',
  },
  {
    q: '网站内容更新频率是怎样的？',
    a: '911吃瓜网运维团队7×24小时不间断监控全网热点，确保重大黑料事件发生后30分钟内上线报道。日常内容保持每日20+条更新量，涵盖明星、网红、商界等多个板块，周末与节假日照常更新不打烊。',
  },
  {
    q: '平台内容是否会涉及侵权问题？',
    a: '我们严格遵守相关法律法规，所有报道均基于已公开信息进行客观陈述与合理评论。如涉及不实内容或侵权投诉，可通过页面联系方式提交删改申请，我们将在24小时内核实处理，维护各方合法权益。',
  },
];

export default function SectionFaq() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于911吃瓜网，你想知道的都在这里
        </p>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-50 rounded-xl border border-secondary-200/60 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors duration-200 list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.q}
                </h3>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform duration-200">
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}